import { render, staticRenderFns } from "./Grid23.vue?vue&type=template&id=42d835d2&scoped=true&"
import script from "./Grid23.vue?vue&type=script&lang=ts&"
export * from "./Grid23.vue?vue&type=script&lang=ts&"
import style0 from "./Grid23.vue?vue&type=style&index=0&id=42d835d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d835d2",
  null
  
)

export default component.exports